{
  "background": {
    "default": {
      "$type": "color",
      "$description": "Page canvas — the base background behind all content.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          210,
          28.571429,
          2.745098
        ],
        "alpha": 1,
        "hex": "#050709"
      }
    },
    "subtle": {
      "$type": "color",
      "$description": "Subtly differentiated background for alternating or grouped sections.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          204,
          15.151515,
          6.470588
        ],
        "alpha": 1,
        "hex": "#0e1113"
      }
    }
  },
  "surface": {
    "default": {
      "$type": "color",
      "$description": "Default container surface — cards, panels, and inputs on the page.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          204,
          15.151515,
          6.470588
        ],
        "alpha": 1,
        "hex": "#0e1113"
      }
    },
    "raised": {
      "$type": "color",
      "$description": "Raised surface for higher-elevation layers (menus, popovers, dialogs). Higher elevation reads lighter in dark mode.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          206.666667,
          11.688312,
          15.098039
        ],
        "alpha": 1,
        "hex": "#22272b"
      }
    },
    "sunken": {
      "$type": "color",
      "$description": "Recessed surface for wells and inset regions.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          210,
          28.571429,
          2.745098
        ],
        "alpha": 1,
        "hex": "#050709"
      }
    }
  },
  "text": {
    "default": {
      "$type": "color",
      "$description": "Primary body and heading text.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          "none",
          0,
          96.078431
        ],
        "alpha": 1,
        "hex": "#f5f5f5"
      }
    },
    "muted": {
      "$type": "color",
      "$description": "Secondary text — supporting copy, captions, metadata.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          200,
          9.89011,
          82.156863
        ],
        "alpha": 1,
        "hex": "#cdd3d6"
      }
    },
    "subtle": {
      "$type": "color",
      "$description": "Tertiary text — placeholders and disabled labels. The mid-grey reads in both modes.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          198,
          4.385965,
          55.294118
        ],
        "alpha": 1,
        "hex": "#888f92"
      }
    },
    "inverse": {
      "$type": "color",
      "$description": "Text and icons rendered on an action or solid fill.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          210,
          28.571429,
          2.745098
        ],
        "alpha": 1,
        "hex": "#050709"
      }
    },
    "link": {
      "$type": "color",
      "$description": "Inline hyperlink text.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          196.173913,
          100,
          77.45098
        ],
        "alpha": 1,
        "hex": "#8ce0ff"
      }
    }
  },
  "border": {
    "default": {
      "$type": "color",
      "$description": "Default border for inputs, cards, and dividers.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          204,
          8.62069,
          22.745098
        ],
        "alpha": 1,
        "hex": "#353b3f"
      }
    },
    "subtle": {
      "$type": "color",
      "$description": "Low-emphasis border for subtle separation.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          206.666667,
          11.688312,
          15.098039
        ],
        "alpha": 1,
        "hex": "#22272b"
      }
    },
    "strong": {
      "$type": "color",
      "$description": "High-emphasis border for focus and selected states.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          198,
          4.385965,
          55.294118
        ],
        "alpha": 1,
        "hex": "#888f92"
      }
    }
  },
  "action": {
    "default": {
      "$type": "color",
      "$description": "Primary interactive colour — buttons, links, key accents. NSW navy in light, brightened for contrast in dark.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          202.396313,
          100,
          57.45098
        ],
        "alpha": 1,
        "hex": "#26aeff"
      }
    },
    "hover": {
      "$type": "color",
      "$description": "Hover and active state for primary actions.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          196.173913,
          100,
          77.45098
        ],
        "alpha": 1,
        "hex": "#8ce0ff"
      }
    },
    "subtle": {
      "$type": "color",
      "$description": "Tinted background for low-emphasis (ghost) actions.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          222.545455,
          100,
          10.784314
        ],
        "alpha": 1,
        "hex": "#001037"
      }
    }
  },
  "success": {
    "surface": {
      "$type": "color",
      "$description": "Success (positive outcomes and confirmations) — tinted background.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          120,
          100,
          4.313725
        ],
        "alpha": 1,
        "hex": "#001600"
      }
    },
    "text": {
      "$type": "color",
      "$description": "Success (positive outcomes and confirmations) — readable text on the tint.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          115.081967,
          35.260116,
          66.078431
        ],
        "alpha": 1,
        "hex": "#8fc78a"
      }
    },
    "border": {
      "$type": "color",
      "$description": "Success (positive outcomes and confirmations) — border and divider.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          121.333333,
          100,
          17.647059
        ],
        "alpha": 1,
        "hex": "#005a02"
      }
    },
    "solid": {
      "$type": "color",
      "$description": "Success (positive outcomes and confirmations) — solid fill for badges and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          118.181818,
          47.826087,
          40.588235
        ],
        "alpha": 1,
        "hex": "#399936"
      }
    }
  },
  "warning": {
    "surface": {
      "$type": "color",
      "$description": "Warning (caution and pending states) — tinted background.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          6.153846,
          100,
          7.647059
        ],
        "alpha": 1,
        "hex": "#270400"
      }
    },
    "text": {
      "$type": "color",
      "$description": "Warning (caution and pending states) — readable text on the tint.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          18,
          74.626866,
          73.72549
        ],
        "alpha": 1,
        "hex": "#eea88a"
      }
    },
    "border": {
      "$type": "color",
      "$description": "Warning (caution and pending states) — border and divider.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          19.849624,
          95.683453,
          27.254902
        ],
        "alpha": 1,
        "hex": "#882f03"
      }
    },
    "solid": {
      "$type": "color",
      "$description": "Warning (caution and pending states) — solid fill for badges and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          19.245283,
          64.37247,
          51.568627
        ],
        "alpha": 1,
        "hex": "#d36734"
      }
    }
  },
  "danger": {
    "surface": {
      "$type": "color",
      "$description": "Danger (errors and destructive actions) — tinted background.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          356.571429,
          100,
          6.862745
        ],
        "alpha": 1,
        "hex": "#230002"
      }
    },
    "text": {
      "$type": "color",
      "$description": "Danger (errors and destructive actions) — readable text on the tint.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          358.636364,
          67.692308,
          74.509804
        ],
        "alpha": 1,
        "hex": "#ea9294"
      }
    },
    "border": {
      "$type": "color",
      "$description": "Danger (errors and destructive actions) — border and divider.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          347.288136,
          90.769231,
          25.490196
        ],
        "alpha": 1,
        "hex": "#7c061f"
      }
    },
    "solid": {
      "$type": "color",
      "$description": "Danger (errors and destructive actions) — solid fill for badges and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          353.333333,
          54.216867,
          51.176471
        ],
        "alpha": 1,
        "hex": "#c63f4e"
      }
    }
  },
  "info": {
    "surface": {
      "$type": "color",
      "$description": "Info (neutral information) — tinted background.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          228.461538,
          86.666667,
          5.882353
        ],
        "alpha": 1,
        "hex": "#02071c"
      }
    },
    "text": {
      "$type": "color",
      "$description": "Info (neutral information) — readable text on the tint.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          218.181818,
          35.106383,
          63.137255
        ],
        "alpha": 1,
        "hex": "#8098c2"
      }
    },
    "border": {
      "$type": "color",
      "$description": "Info (neutral information) — border and divider.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          219.74026,
          60.629921,
          24.901961
        ],
        "alpha": 1,
        "hex": "#193366"
      }
    },
    "solid": {
      "$type": "color",
      "$description": "Info (neutral information) — solid fill for badges and icons.",
      "$value": {
        "colorSpace": "hsl",
        "components": [
          219.183673,
          42.608696,
          45.098039
        ],
        "alpha": 1,
        "hex": "#4264a4"
      }
    }
  }
}
